'use strict';

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

angular.module('ClinicApp').directive('profilePhotos', function(OCPhotoUtil, OCModalUtil, ClinicConfig, PhotoService) {
  return {
    scope: {
      model: '=',
      modelType: '=',
    },
    templateUrl: '/views/directives/_profile-photos.html',
    link: function($scope) {
      if (['clinic', 'doctor'].indexOf($scope.modelType) === -1) {
        throw new Error('DirectiveArgumentError: `profilePhotos` invalid modelType "' + $scope.modelType + '".');
      }
      $scope.modelTypeCapitalized = capitalizeFirstLetter($scope.modelType);
      $scope.formattedModelType = $scope.modelType == 'clinic' ? 'practice' : $scope.modelType;

      var resourceURI = ClinicConfig.HOSTNAME + '/' + $scope.modelType + '/' + $scope.model.id + '/photo';
      $scope.loading = false;

      $scope.$on('reload' + $scope.modelTypeCapitalized + 'Done', function() {
        $scope.loading = false;
      });

      $scope.uploadPhoto = function() {
        angular.element('#file-input').click();
      };

      $scope.fileSelected = function() {
        var file = document.querySelector('#file-input').files[0];
        if (!file) {
          return;
        }
        $scope.loading = true;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function() {
          OCPhotoUtil.uploadPhotoDataURI(resourceURI, reader.result).then(function() {
            $scope.$emit('reload' + $scope.modelTypeCapitalized);
          });
        };
      };

      $scope.sortableOptions = {
        stop: function() {
          $scope.updateOrder();
        },
        tolerance: 'pointer',
        containment: 'parent',
      };

      $scope.deletePhoto = function(photo) {
        return OCModalUtil.showModal(
          'confirm',
          'This photo will be permanently deleted. Are you sure you want to continue?',
        ).then(function() {
          $scope.loading = true;
          return PhotoService.deletePhoto($scope.modelType, $scope.model.id, photo.name).finally(function() {
            $scope.$emit('reload' + $scope.modelTypeCapitalized);
          });
        });
      };

      $scope.updateOrder = function() {
        $scope.loading = true;
        var photoOrder = {};
        _.each($scope.model.photos, function(photo, index) {
          photoOrder[photo.name] = index;
        });
        PhotoService.orderPhotos($scope.modelType, $scope.model.id, photoOrder).finally(function() {
          $scope.$emit('reload' + $scope.modelTypeCapitalized);
        });
      };

      $scope.openPhotoViewer = function(index) {
        if (!$scope.model.photos.length) {
          return;
        }
        $scope.photoViewerIndex = index;
        $scope.showPhotoViewer = true;
      };

      $scope.closePhotoViewer = function() {
        $scope.showPhotoViewer = false;
      };
    },
  };
});
